import { render, staticRenderFns } from "./Nav.vue?vue&type=template&id=176bbc42&scoped=true&"
var script = {}
import style0 from "./Nav.vue?vue&type=style&index=0&id=176bbc42&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176bbc42",
  null
  
)

export default component.exports